import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Chọn tài khoản", -1)
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"width":"20px"} }
const _hoisted_7 = { class: "flex align-items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"width":"20px"} }
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa/phòng", -1)
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Đăng ký", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Thêm tài khoản nhân viên vào khoa phòng" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Dropdown, {
            modelValue: $setup.customer,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customer) = $event)),
            options: $setup.listCustomer,
            optionLabel: "name",
            placeholder: "Chọn tài khoản",
            filter: true,
            style: {"height":"35px"}
          }, {
            value: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_4, [
                (slotProps.value.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: slotProps.value.imageUrl,
                      style: {"width":"20px","margin-right":"3px"}
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_6, _toDisplayString(slotProps.value.name), 1)
              ])
            ]),
            option: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_7, [
                (slotProps.option.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: slotProps.option.imageUrl,
                      style: {"width":"20px","margin-right":"3px"}
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_9, _toDisplayString(slotProps.option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_Dropdown, {
            modelValue: $setup.teamId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.teamId) = $event)),
            options: $setup.teams,
            optionLabel: "name",
            optionValue: "code",
            placeholder: "Chọn khoa/ phòng",
            filter: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_Button, {
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.doRegister()))
          })
        ])
      ])
    ]),
    _: 1
  }))
}